import React from 'react';

import { Typography } from '@mui/material';
import { useServiceRouter } from '@common/components/ServiceRouter';

import * as Styled from './styled';

interface PropsType {
	imgSrc: string;
	title: string;
	description: string;
	descriptionLyceum?: string;
}

function ChatRulesModalStep({ imgSrc, title, description, descriptionLyceum }: PropsType) {
	const { checkService } = useServiceRouter();

	return (
		<Styled.Wrap>
			<Styled.Image src={imgSrc} alt="Step image" />
			<Styled.InfoWrap>
				<Typography variant="subtitle1" color="error.contrastText">
					{title}
				</Typography>
				<Typography>{checkService('lyceum') ? (descriptionLyceum || description) : description}</Typography>
			</Styled.InfoWrap>
		</Styled.Wrap>
	);
}

export default ChatRulesModalStep;
